module.exports = __webpack_public_path__ + "static/media/Logo.8d9c827e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Logo.svg
// module id = 109
// module chunks = 11